import * as React from 'react';
export const paytoSvg = React.forwardRef(function paytoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.384 0H3.616A3.62 3.62 0 0 0 0 3.621v8.764A3.615 3.615 0 0 0 3.619 16h8.765A3.616 3.616 0 0 0 16 12.385V3.62A3.614 3.614 0 0 0 12.384 0ZM9.301 11.942a3.055 3.055 0 0 1 0-6.103h3.443v-.947l1.771 1.472-1.773 1.476v-.97H9.257c-1.067 0-1.949.954-1.949 2.02a1.995 1.995 0 1 0 3.986 0 2.38 2.38 0 0 0-.391-1.278h1.17c.184.4.28.836.28 1.277a3.025 3.025 0 0 1-3.052 3.052Zm-4.239-1.06c.244-.012.485-.059.716-.139v1.05c-.228.092-.47.142-.716.15a1.908 1.908 0 0 1-1.892-1.918V6.87H1.977V5.84H3.17V4.53h1.036v1.31h2.826a3.9 3.9 0 0 0-1.024 1.03H4.207v3.153a.862.862 0 0 0 .856.857Z',
    }),
  );
});
paytoSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var payto = {
  category: 'paymentmethod',
  colorable: true,
  name: 'payto',
  svg: paytoSvg,
};
